<div
  *ngIf="loading"
  class="fixed top-0 left-0 w-screen h-screen flex items-center justify-center z-10"
>
  <div class="bg-gray-100 opacity-50 h-screen w-screen absolute"></div>
  <mat-spinner></mat-spinner>
</div>
<section class="relative">
  <div class="flex items-center p-10 pb-0 pt-5">
    <a
      [routerLink]="
        type === 'sale' ? ['/sale-product'] : ['/subscription-month']
      "
      [queryParams]="discount ? { disc: discount } : {}"
      class="text-sm py-1 font-semibold text-primary hover:text-secondary transition ease-linear"
    >
      < Volver a {{ type === "sale" ? "Tienda" : "Suscripciones" }}
    </a>
  </div>

  <div
    class="grid grid-cols-1 md:grid-cols-2 bg-white rounded-2xl mb-5 mt-5 md:m-10 shadow-medium md:shadow-strong"
    *ngIf="product"
  >
    <!-- Carousel con soporte para imágenes 360 -->
    <app-carousel
      [images]="images"
      [images360]="images360"
      [productName]="product.name"
    >
    </app-carousel>

    <div *ngIf="!loading" class="col-span-1 p-5 text-center md:text-left">
      <!--DATOS DEL PRODUCTO-->
      <div class="inline-block mx-auto md:mx-0">
        <h1 class="text-primary font-bold text-3xl mb-2">{{ product.name }}</h1>
        <div
          class="h-0.5 bg-gradient-to-r from-primary to-secondary rounded-full mb-4"
        ></div>
      </div>
      <div
        class="text-primary mt-2 text-sm"
        [innerHTML]="product.description"
      ></div>

      <div
        class="h-0.5 w-full bg-gradient-to-r from-primary to-secondary my-4"
        *ngIf="
          ((zip_code && product.periodicity?.length > 0) ||
            (!zip_code && product.periodicity?.length > 0)) &&
          product?.allow_self_contracting !== 0
        "
      ></div>

      <!-- Si no tiene descuento -->
      <div
        *ngIf="
          ((zip_code && product.periodicity?.length > 0) ||
            (!zip_code && product.periodicity?.length > 0)) &&
          !discount &&
          product?.allow_self_contracting !== 0
        "
        class="mb-4 md:mb-0"
      >
        <p
          class="text-sm font-medium text-primary mt-5"
          *ngIf="type !== 'sub' && saleOrSubs"
        >
          {{ saleOrSubs }}
        </p>
        <div *ngIf="type === 'sale'" class="font-normal text-sm">
          <div class="bg-white my-4 w-full">
            <!-- Precio de lista sin descuento -->
            <div class="mb-3">
              <div class="hidden sm:flex sm:flex-row sm:items-center sm:gap-2">
                <span class="text-primary text-base font-medium"
                  >Precio de lista:</span
                >
                <strong class="line-through text-secondary"
                  >${{ formatNumber(product?.tachado) }}</strong
                >
                <div
                  class="bg-secondary text-white font-bold py-1 px-3 rounded-full text-sm"
                >
                  {{ getSalePrice(product, 0)?.percentage }}%
                </div>
              </div>
              <div class="flex flex-col sm:hidden">
                <span class="text-primary text-sm font-medium mb-1"
                  >Precio de lista:</span
                >
                <strong class="line-through text-secondary mb-1"
                  >${{ formatNumber(product?.tachado) }}</strong
                >
                <div
                  class="bg-secondary text-white font-bold py-1 px-3 rounded-full text-sm w-max mx-auto"
                >
                  {{ getSalePrice(product, 0)?.percentage }}%
                </div>
              </div>
            </div>
            <p class="text-xs text-gray-500 mb-2">
              Precio sin impuestos nacionales: ${{
                formatNumber(landingService.priceWithoutIva(product))
              }}
            </p>
            <!-- Precio final en tarjeta destacada -->
            <div class="bg-primary text-white rounded-lg p-5 mb-3">
              <p class="text-xs uppercase tracking-wider">Precio final</p>
              <div class="flex flex-col md:items-center md:justify-between">
                <div class="text-3xl font-bold my-2">
                  ${{ formatNumber(getSalePrice(product, 0)?.price) }}
                </div>
                <img
                  class="bg-gray-100 rounded-lg w-full h-auto"
                  src="assets/formas_de_pago.png"
                  alt="Mercado Pago logo"
                />
              </div>
              <div
                class="bg-white/20 backdrop-blur-sm rounded-lg p-2 mt-3 border border-white/30"
              >
                <div class="text-center">
                  <span class="text-xs uppercase tracking-wider"
                    >ENVÍO GRATIS *</span
                  >
                </div>
              </div>
              <!-- Cuotas sin interés dentro de la tarjeta -->
              <div
                class="bg-white/20 backdrop-blur-sm rounded-lg p-2 mt-3 border border-white/30"
              >
                <div class="text-center">
                  <span class="text-xs uppercase tracking-wider"
                    >HASTA 6 CUOTAS SIN INTERÉS DE</span
                  >
                  <div class="text-xl font-bold">
                    ${{
                      calculateInterestFreeInstallments(
                        getSalePrice(product, 0)?.price,
                        6
                      )
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="type === 'sub'">
          <div
            class="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-2 md:px-4 my-2"
          >
            <div class="text-center md:text-left">
              <div
                class="flex items-baseline justify-center md:justify-start gap-2 mb-1"
              >
                <p class="text-3xl font-bold text-primary">
                  ${{ formatNumber(getPrice(product)?.price) }}
                </p>
                <p class="text-sm text-gray-700">{{ isSubsText }}</p>
              </div>
            </div>
            <div
              class="h-0.5 w-full bg-gradient-to-r from-gray-200 via-primary/20 to-gray-200 rounded-full my-3"
            ></div>
            <div class="flex flex-col gap-1.5 text-primary">
              <div class="flex items-center gap-2">
                <svg
                  class="w-4 h-4 text-secondary flex-shrink-0"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span class="text-sm font-semibold">
                  <span *ngIf="getPrice(product)?.cost == 0"
                    >Instalación Gratis</span
                  >
                  <span *ngIf="getPrice(product)?.cost != 0"
                    >${{ formatNumber(getPrice(product)?.cost) }} costo de
                    instalación</span
                  >
                </span>
              </div>
              <div class="flex items-center gap-2">
                <svg
                  class="w-4 h-4 text-secondary flex-shrink-0"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z" />
                  <path
                    fill-rule="evenodd"
                    d="M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span class="text-sm font-semibold">{{ paymentMethod }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Si tiene descuento -->
      <div
        *ngIf="
          ((zip_code && product.periodicity?.length > 0) ||
            (!zip_code && product.periodicity?.length > 0)) &&
          discount &&
          product?.allow_self_contracting !== 0
        "
        class="mb-4 md:mb-0"
      >
        <p class="text-xs font-medium text-gray-600 mt-4 mb-1">Servicio</p>
        <div
          class="bg-gradient-to-br from-secondary/5 to-green-50 rounded-2xl p-4 my-3"
        >
          <!-- Precio con descuento -->
          <div class="flex flex-col gap-2">
            <div class="flex items-center gap-2">
              <span class="line-through text-gray-400 text-base"
                >${{ formatNumber(getPrice(product).original_price) }}</span
              >
              <div
                class="bg-gradient-to-r from-secondary to-green-600 text-white text-xs font-bold px-2 py-0.5 rounded-full shadow-sm animate-pulse"
              >
                PROMOCIÓN
              </div>
            </div>
            <div class="text-3xl font-bold text-primary">
              ${{ formatNumber(getPrice(product).price) }}
            </div>
            <span class="text-xs text-gray-700 font-medium">{{
              getPrice(product).periodicity_label
            }}</span>
          </div>

          <div
            class="h-0.5 w-full bg-gradient-to-r from-gray-200 via-secondary/20 to-gray-200 rounded-full my-3"
          ></div>

          <!-- Costo de instalación -->
          <div class="flex flex-col gap-1.5">
            <div class="flex items-center gap-2">
              <svg
                class="w-4 h-4 text-secondary flex-shrink-0"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clip-rule="evenodd"
                />
              </svg>
              <span class="line-through text-gray-400 text-xs"
                >${{ formatNumber(getPrice(product)?.original_cost) }} costo de
                instalación</span
              >
            </div>
            <span
              class="text-secondary font-bold text-xs flex items-center gap-2"
              *ngIf="getPrice(product)?.cost == 0"
            >
              <svg
                class="w-4 h-4 flex-shrink-0"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clip-rule="evenodd"
                />
              </svg>
              Instalación Gratis
            </span>
            <div class="flex items-center gap-2 mt-1">
              <svg
                class="w-4 h-4 text-primary flex-shrink-0"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z" />
                <path
                  fill-rule="evenodd"
                  d="M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z"
                  clip-rule="evenodd"
                />
              </svg>
              <span class="font-medium text-sm text-primary"
                >Solo Tarjeta de Crédito</span
              >
            </div>
          </div>
        </div>
      </div>

      <!-- Show a no-coverage banner when the store returned null for the given zip -->
      <div
        *ngIf="
          noCoverage ||
          (zip_code &&
            (!product ||
              !product.periodicity ||
              product.periodicity.length <= 0))
        "
      >
        <div
          class="font-bold text-white rounded-lg bg-red-500 py-2 px-5 text-center mt-5"
        >
          Lamentablemente no tenemos cobertura en tu zona.
        </div>
        <div class="mt-3 text-center">
          <a
            class="font-medium text-primary cursor-pointer underline"
            (click)="gotoProduct()"
            >¿Desea probar con otro código postal?</a
          >
        </div>
      </div>

      <!-- Purchase controls: only show when product has periodicity and we have coverage -->
      <div
        *ngIf="
          !noCoverage &&
          zip_code &&
          product &&
          product.periodicity &&
          product.periodicity.length > 0 &&
          product?.allow_self_contracting !== 0
        "
      >
        <div
          class="h-0.5 w-full bg-gradient-to-r from-primary to-secondary my-4"
        ></div>

        <div class="my-5 mx-0 md:m-5 md:ml-0 flex flex-col items-center">
          <button
            (click)="purchaseProduct()"
            class="bg-gradient-to-br from-primary to-blue-900 font-bold px-10 py-3 rounded-full text-white hover:shadow-strong shadow-medium transition-all duration-300 hover:scale-105"
          >
            {{ purchaseType }}
          </button>

          <div
            class="font-bold text-white rounded-lg bg-green-500 py-2 px-5 text-center mt-5 w-full md:w-fit"
          >
            Tenemos cobertura en tu zona.
          </div>
        </div>
      </div>

      <!-- Message when self-contracting is not allowed -->
      <div
        class="my-5 mx-0 md:m-5 md:ml-0 flex flex-col items-center"
        *ngIf="
          !noCoverage &&
          zip_code &&
          product &&
          product.periodicity &&
          product.periodicity.length > 0 &&
          product?.allow_self_contracting === 0
        "
      >
        <div
          class="font-bold text-white rounded-lg bg-secondary py-3 px-5 text-center w-full md:w-fit"
        >
          Para contratar este producto, consultanos directamente a través de
          WhatsApp haciendo
          <a
            [href]="getWhatsAppLink(product?.name || '')"
            target="_blank"
            class="underline hover:text-gray-200"
            >click acá</a
          >.
        </div>
        <div
          class="font-bold text-white rounded-lg bg-green-500 py-2 px-5 text-center mt-5 w-full md:w-fit"
        >
          Tenemos cobertura en tu zona.
        </div>
      </div>
      <div class="text-center" *ngIf="type === 'sale'">
        <!-- <div *ngIf="isQuantity" class="flex items-center gap-4 mb-5">
          <button
            class="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
            (click)="decrease()"
          >
            -
          </button>
          <span class="text-lg font-semibold">{{ quantity }}</span>
          <button
            class="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600"
            (click)="increase()"
          >
            +
          </button>
          <select
            class="px-2 py-1 border rounded-lg"
            (change)="setQuantity($event)"
          >
            <option
              *ngFor="let option of quantityOptions"
              [value]="option"
              [selected]="option === quantity"
            >
              {{ option }}
            </option>
          </select>
        </div> -->

        <button
          *ngIf="product?.allow_self_contracting !== 0"
          (click)="purchaseProduct()"
          class="bg-gradient-to-br from-primary to-blue-900 w-full text-2xl mx-auto md:mx-0 font-bold py-4 rounded-2xl text-white hover:shadow-strong shadow-medium transition-all duration-300 hover:scale-105"
        >
          <div class="flex justify-center items-center gap-2">
            <span class="material-symbols-outlined"> shopping_cart </span>
            {{ purchaseType }}
          </div>
        </button>

        <!-- Message when self-contracting is not allowed for sales -->
        <div
          *ngIf="product?.allow_self_contracting === 0"
          class="font-bold text-white rounded-lg bg-secondary py-3 px-5 text-center mt-4 mx-auto md:mx-0 w-fit md:w-auto"
        >
          Para comprar este producto, consultanos directamente a través de
          WhatsApp haciendo
          <a
            [href]="getWhatsAppLink(product?.name || '')"
            target="_blank"
            class="underline hover:text-gray-200"
            >click acá</a
          >.
        </div>

        <div
          class="bg-gray-100 backdrop-blur-sm rounded-lg p-2 mt-6 border border-gray-200 shadow-none md:shadow-sm"
        >
          <div class="flex flex-col text-center">
            <div class="font-normal text-xs space-y-1 text-left inline-block">
              <p>
                <span class="font-bold">•</span> CABA y GBA:
                <span class="font-semibold">1 día hábil</span>.
              </p>
              <p>
                <span class="font-bold">•</span> Pcia de Bs As, Capitales de
                Córdoba, Entre Ríos, Mendoza, Neuquén y Santa Fé:
                <span class="font-semibold">Hasta 3 días hábiles</span>.
              </p>
              <p>
                <span class="font-bold">•</span> Resto de Provincias
                continentales:
                <span class="font-semibold">Hasta 7 días hábiles</span>.
              </p>
              <p>
                <span class="font-bold">•</span> Tierra del Fuego:
                <span class="font-semibold">Hasta 14 días hábiles</span>.
              </p>
            </div>
          </div>
        </div>
      </div>
      <ng-container
        *ngIf="
          !noCoverage &&
          zip_code &&
          product &&
          product.periodicity &&
          product.periodicity.length > 0
        "
      >
        <div class="mt-5 text-center">
          <a
            class="font-medium text-primary cursor-pointer"
            (click)="gotoProduct()"
            >¿Desea cambiar su código postal?</a
          >
        </div>
        <!--<mat-form-field appearance="outline" class="mt-0">
          <mat-label>Seleccionar Pago</mat-label>
          <mat-select>
            <mat-option
              *ngFor="let periodicity of product.periodicity"
              (click)="selectPeriodicity(periodicity)"
              [value]="periodicity.id"
            >
              {{ periodicity.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div *ngIf="zip_code && selectedPeriodicity" class="text-primary">
          <p class="text-sm font-medium">Suscripción</p>
          <p>
            <span class="text-sm"
              ><span class="text-2xl font-bold"
                >${{ selectedPeriodicity?.pivot?.periodic_price }}</span
              >
              x mes</span
            >
          </p>
          <button
            *ngIf="product?.allow_self_contracting !== 0"
            (click)="purchaseProduct()"
            class="bg-primary mx-auto md:mx-0 text-lg font-medium px-4 py-1 rounded-full text-white mt-4 flex items-center"
          >
            Contratar
          </button>
        </div>-->
      </ng-container>

      <div
        class="h-0.5 w-full bg-gradient-to-r from-primary to-secondary my-4"
        *ngIf="!zip_code && product && type === 'sub'"
      ></div>

      <form
        [formGroup]="zipForm"
        (ngSubmit)="onSubmit()"
        *ngIf="!zip_code && product && type === 'sub'"
      >
        <div
          class="flex flex-col items-center justify-start md:flex-row md:items-center md:justify-start gap-4"
        >
          <div
            class="text-sm font-medium text-gray-500 text-center md:text-left"
          >
            Ingresá tu código postal y<br />
            verificá la disponibilidad.
          </div>
          <input
            formControlName="zipCode"
            type="number"
            placeholder="Código Postal"
            class="border border-gray-300 rounded-lg px-4 py-3 text-lg font-medium text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent w-full md:w-48"
          />
          <button
            type="submit"
            [disabled]="zipForm.invalid"
            class="bg-primary text-sm font-medium rounded-full text-white hover:bg-secondary transition ease-linear px-7 py-3 w-full md:w-auto"
          >
            Verificar
          </button>
        </div>

        <div class="text-sm font-medium text-gray-500 mb-6 mt-4">
          Por cualquier consulta comunicate a través de
          <a
            href="https://wa.me/5491168786533"
            target="_blank"
            class="text-green-500 hover:text-gray-500"
            >WhatsApp</a
          >
        </div>
      </form>
    </div>
  </div>
  <!--<section *ngIf="false" class="bg-white md:px-20 px-4 md:py-20 py-4 text-primary text-center">
    <h1>Un plan que asegura agua confiable para toda la familia </h1>
    <h2 class="text-xl font-semibold mt-4">2 etapas de filtrado</h2>
    <div>
      <div class="text-left">
        <h1 class="text-semibold text-primary">Filtro de Carbón activado</h1>
        <span>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</span>
      </div>
    </div>
  </section>-->
</section>
<app-whyus></app-whyus>
<app-our-filters></app-our-filters>
<section
  *ngIf="productsForSubs.length > 0 && type === 'sub'"
  class="relative py-16 bg-gradient-to-b from-gray-50 to-white"
>
  <div class="text-center max-w-7xl mx-auto px-5 mb-12">
    <h1 class="text-primary text-3xl md:text-4xl font-bold mb-4">
      Productos <span class="text-secondary">Relacionados</span>
    </h1>
    <div class="h-1 w-24 bg-secondary rounded-full mx-auto"></div>
  </div>
  <div class="flex items-center justify-center mx-0 mb-8">
    <div class="md:flex flex-wrap px-0 md:px-10 gap-10 justify-center z-10">
      <div
        *ngFor="let product of productsForSubs"
        (click)="product?.out_of_stock !== 1 && productDetail(product, 'sub')"
        class="mb-4 md:mb-0 flex flex-col group bg-white hover:shadow-strong shadow-medium rounded-2xl p-6 text-center transition-all duration-500 ease-out"
        [class.cursor-not-allowed]="product?.out_of_stock === 1"
        [class.cursor-pointer]="product?.out_of_stock !== 1"
        style="
          user-select: none;
          width: 300px;
          min-height: 520px;
          max-width: 300px;
        "
      >
        <div
          class="text-center flex-shrink-0 flex flex-col justify-center items-center bg-gradient-to-b from-gray-50 to-white rounded-xl p-4 mb-4"
        >
          <div
            class="relative flex justify-center items-center"
            style="height: 190px; width: 100%"
          >
            <img
              class="group-hover:scale-110 mx-auto transform transition duration-500 ease-out object-contain drop-shadow-md"
              style="height: 180px; max-width: 100%"
              [src]="product?.imageUrl"
              alt=""
            />
          </div>
          <div
            *ngIf="product?.out_of_stock === 1"
            class="bg-gradient-to-r from-red-500 to-red-600 font-bold text-center py-2 px-6 rounded-full text-white text-sm w-fit shadow-medium mt-2"
          >
            AGOTADO
          </div>
          <div
            *ngIf="
              product?.allow_self_contracting === 0 &&
              product?.out_of_stock !== 1
            "
            class="bg-gradient-to-r from-secondary to-green-600 font-bold text-center py-2 px-6 rounded-full text-white text-sm w-fit shadow-medium mt-2"
          >
            CONSULTANOS
          </div>
        </div>

        <div
          class="h-0.5 w-16 bg-gradient-to-r from-primary to-secondary rounded-full mx-auto my-4"
        ></div>

        <div class="text-primary font-bold text-2xl pb-2 leading-tight">
          {{ product?.name }}
        </div>

        <div class="flex items-end justify-center">
          <img src="assets/vaso_frio.png" alt="" class="w-21 h-37 pr-4 my-1" />
          <img src="assets/vaso_caliente.png" alt="" class="w-21 h-37 my-1" />
        </div>

        <div
          *ngIf="product?.short_description"
          [innerHTML]="product?.short_description"
          class="text-sm text-gray-500 mb-1"
        ></div>

        <!--<div *ngIf="product?.description" [innerHTML]="product?.description" class="text-sm text-gray-500 mb-8"></div>-->

        <div
          *ngIf="getPrice(product) && product?.allow_self_contracting !== 0"
          class="mt-auto"
        >
          <!-- Si hay descuento -->
          <div
            class="font-normal text-sm"
            *ngIf="getPrice(product).original_price != getPrice(product).price"
          >
            <span
              style="text-decoration-line: line-through"
              class="text-primary text-lg font-semibold"
            >
              ${{ formatNumber(getPrice(product).original_price) }}
            </span>
            <div class="relative flex items-center justify-center">
              <div
                class="bg-gradient-to-br from-primary to-blue-900 font-bold text-center py-3 px-8 rounded-2xl text-white w-full shadow-medium"
              >
                <div class="absolute" style="top: -12px; right: -12px">
                  <div
                    class="rounded-full text-sm font-bold bg-gradient-to-br from-secondary to-green-600 text-white p-2 w-12 h-12 flex items-center justify-center shadow-strong animate-pulse"
                    style="z-index: 10"
                  >
                    {{ getPrice(product).percentage }}%
                  </div>
                </div>
                <span class="text-xl">
                  ${{ formatNumber(getPrice(product).price) }}
                </span>
                <br />
                <span class="font-light text-xs">
                  {{ getPrice(product).periodicity_label }}
                </span>
              </div>
            </div>

            <p class="mt-2">
              <span class="text-xs">
                <span
                  *ngIf="getPrice(product)?.cost == 0"
                  class="block text-green-500"
                >
                  Instalación Gratis
                </span>
              </span>
              <span
                *ngIf="getPrice(product)?.original_cost == 0"
                class="block text-green-500"
              >
                Instalación Gratis
              </span>
              <span
                *ngIf="getPrice(product)?.original_cost != 0"
                class="block"
                style="
                  color: rgb(248 113 113);
                  text-decoration-line: line-through;
                "
              >
                Costo de instalación: ${{
                  formatNumber(getPrice(product)?.original_cost)
                }}
              </span>
              <span
                class="font-normal text-gray-500 leading-none"
                style="font-size: 10px"
                >Precio sin impuestos nacionales: ${{
                  formatNumber(landingService.priceWithoutIva(product))
                }}
              </span>
            </p>
          </div>

          <!-- Si no tiene descuento -->
          <div
            *ngIf="getPrice(product).original_price == getPrice(product).price"
          >
            <button
              class="bg-gradient-to-br from-primary to-blue-900 font-bold text-center py-3 px-10 rounded-full text-white w-fit shadow-medium hover:shadow-strong transition-all duration-300"
            >
              <span>${{ formatNumber(getPrice(product).original_price) }}</span>

              <span class="font-normal text-sm">{{
                getPrice(product).periodicity
              }}</span>
            </button>

            <p class="mt-2">
              <span class="block text-xs text-primary font-semibold">
                <span *ngIf="getPrice(product)?.original_cost == 0"
                  >Instalación Gratis</span
                >
                <span *ngIf="getPrice(product)?.original_cost != 0"
                  >Costo de instalación ${{
                    formatNumber(getPrice(product)?.original_cost)
                  }}</span
                >
              </span>
              <span
                class="font-normal text-gray-500 leading-none mt-0 pt-0"
                style="font-size: 9px"
                >Precio sin impuestos nacionales: ${{
                  formatNumber(landingService.priceWithoutIva(product))
                }}
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<app-certificated-filter></app-certificated-filter>
<!--<app-landing-subscription-steps></app-landing-subscription-steps>
<app-landing-faqs></app-landing-faqs>-->
